import { useState, useEffect, useRef } from "react";
import { ClockIcon } from "lucide-react";

export default function TimeSlotSelector({ onClose, onSelect }) {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const modalRef = useRef(null);

  // Load time slots when component mounts
  useEffect(() => {
    fetchTimeSlots();

    // Add event listener for clicks outside the modal
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  const fetchTimeSlots = async () => {
    try {
      // Replace with your actual API call
      setTimeout(() => {
        const mockSlots = [
          { id: "1", startTime: "2:00pm", endTime: "3:00pm", date: "Today" },
          { id: "2", startTime: "3:00pm", endTime: "4:00pm", date: "Today" },
          { id: "3", startTime: "4:00pm", endTime: "5:00pm", date: "Today" },
          { id: "4", startTime: "5:00pm", endTime: "6:00pm", date: "Today" },
        ];
        setAvailableSlots(mockSlots);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching time slots:", error);
      setLoading(false);
    }
  };

  const handleSelectSlot = (slotId) => {
    setSelectedSlot(slotId);
  };

  const handleBookSlot = () => {
    onSelect(selectedSlot);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div ref={modalRef} className="bg-white rounded-lg max-w-md w-full max-h-[90vh] flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-semibold">Available Time Slots</h2>
        </div>

        <div className="flex-1 overflow-auto px-6 py-4">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="w-8 h-8 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {availableSlots.map((slot) => (
                <div
                  key={slot.id}
                  className={`cursor-pointer border rounded-lg 
                    ${selectedSlot === slot.id ? "border-gray-500 bg-blue-50" : "border-gray-200 hover:border-gray-300"}`}
                  onClick={() => handleSelectSlot(slot.id)}
                >
                  <div className="p-4 flex items-center">
                    <div>
                      <div className="font-medium">
                        {slot.startTime} - {slot.endTime}
                      </div>
                      <div className="text-sm text-gray-500">{slot.date}</div>
                    </div>
                  </div>
                </div>
              ))}

              {availableSlots.length === 0 && !loading && <div className="col-span-2 text-center py-8 text-gray-500">No available slots found.</div>}
            </div>
          )}
        </div>

        <div className="p-6 flex justify-between gap-3 w-full">
          <button className="flex-1 px-4 py-2 border border-gray-300 rounded-md" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`flex-1 px-4 py-2 bg-black text-white rounded-md ${!selectedSlot ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={handleBookSlot}
            disabled={!selectedSlot}
          >
            Book This Slot
          </button>
        </div>
      </div>
    </div>
  );
}
